import Vue from 'vue';
export default Vue.extend({
    props: {
        /** element height  */
        height: { type: String, default: '100%' },
        /** element width  */
        width: { type: String, default: '100%' },
    }
});
